<template>
  <v-container fluid>
    <v-row
      align="center" justify="end" >
      <v-col cols="1"></v-col>
      <v-col cols="10">
        <v-row align="center" justify="center" class="pt-0 mt-0">
          <v-col cols="2">
            <v-img :src="items[0]" width="300"></v-img>
          </v-col>
          <v-col cols="2">
            <v-img :src="items[1]" width="300"></v-img>
          </v-col>
          <v-col cols="2">
            <v-img :src="items[2]" width="300"></v-img>
          </v-col>
          <v-col cols="2"> 
            <v-img :src="items[3]" width="300"></v-img>
          </v-col>
          <v-col cols="2">
            <v-img :src="items[4]" width="300"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../assets/Partners/10micron_p.jpg")
        },
        {
          src: require("../assets/Partners/astrottica_p.jpg")
        },
        {
          src: require("../assets/Partners/columbias2.jpeg")
        },
        {
          src: require("../assets/Partners/reginato_p.jpg")
        },
        {
          src: require("../assets/Partners/planewave_p.png")
        },
      ]
    };
  }
};
</script>
